import GroupMembersIcon from '@/assets/images/common/svg/group-members-icon.svg?react';
import GroupChatHeaderOperation from '@/pages/messages/components/groups/group-chat-header-operation';
// import ChatHeaderTabs from '../chat-header-tabs';
import StatusBox from '@/pages/messages/components/StatusBox';
import ChatHeaderOperation from '../chat-header-operation';
import classes from './index.module.scss';
import type { ChatInfoProps } from './interface';

export default function ChatInfo({
  chat,
  isGroup,
  group,
  normalMemberList,
}: ChatInfoProps) {
  return (
    <div className={classes.chatHeaderInfo}>
      <div className={cls(classes.chatHeaderContent, classes.noTabs)}>
        <div className={classes.chatHeaderTop}>
          {isGroup && <GroupMembersIcon />}
          <div className={classes.chatName}>{chat.name}</div>
          {isGroup ? (
            <div className={classes.members}>
              <StatusBox loading={chat.loading}>
                {normalMemberList?.length > 0 && `${normalMemberList?.length} members`}
              </StatusBox>
            </div>
          ) : (
            <StatusBox loading={chat.loading}></StatusBox>
          )}
          {/* <div className={classes.enterpriseLabel}>@Halo.Chat</div> */}
        </div>
        {!chat.loading && (
          <>
            {isGroup ? (
              <>
                {!!group && (
                  <GroupChatHeaderOperation
                    chat={chat}
                    group={group}
                    normalMemberList={normalMemberList}
                  />
                )}
              </>
            ) : (
              <ChatHeaderOperation chat={chat} />
            )}
          </>
        )}
      </div>
      {/* <ChatHeaderTabs /> */}
    </div>
  );
}
